import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { IsDeviceOnlineService } from 'src/app/services/is-online/is-online.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {
  public isStatusOpen: boolean = false;
  public status: boolean = false;

  isDeviceOnline = false;

  constructor(public authService: AuthService, private readonly _isDeviceOnlineService: IsDeviceOnlineService) {}

  ngOnInit(): void {
    this.authService.user.subscribe((res) => {
      this.status = res?.status;
    });

    this._isDeviceOnlineService.networkStatus$.subscribe({
      next: (status) => (status === 'online' ? (this.isDeviceOnline = true) : (this.isDeviceOnline = false))
    });
  }

  statusToggle() {
    if (this._isDeviceOnlineService.currentNetwork === 'offline') return;
    this.isStatusOpen = !this.isStatusOpen;
  }

  getStatus() {
    const userData: Record<any, any> = this.authService.userData;

    if (userData?.token) {
      this.authService.getStatus().subscribe();
    }
  }

  setStatus(ev: Event) {
    const isChecked: boolean = ev.target['checked'];
    this.authService.setStatus({ status: !isChecked }).subscribe(
      (res) => {
        if (res?.success) this.getStatus();
      },
      (error) => {}
    );
  }
}
